// @flow
import { LoadingSpinner } from 'client-web-app/components';
import React from 'react';
import styled from 'styled-components';

const LoadingPlaceholderLayout = styled.div`
  height: 100%;
  min-height: ${({ minHeight }) => minHeight}px;
  position: relative;
`;

type LoadingPlaceholderProps = {
  minHeight: number,
};

const LoadingPlaceholder = ({ minHeight }: LoadingPlaceholderProps) => (
  <LoadingPlaceholderLayout minHeight={minHeight}>
    <LoadingSpinner />
  </LoadingPlaceholderLayout>
);

export default LoadingPlaceholder;
